import React from 'react'
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { RxCross2 } from "react-icons/rx";
import { useSelector } from 'react-redux';
import  ReactStars from "react-rating-stars-component";
import IconBtn from '../../comman/iconBtn';
import { createRating } from '../../../services/operations/courseDetailsAPI';

export const CourseReviewModel = ({setReviewModal}) => {
  const {user} = useSelector((state) => state.profile);
  const {token} = useSelector((state) => state.auth);
  const { courseEntireData} = useSelector((state) => state.viewCourse)

  // form by using useFrom hook
  const  {
    register,
    handleSubmit,
    setValue,
    formState: {errors},
  } = useForm();

  // setting the initail value 
  useEffect(() =>{
    setValue("courseExperience", "");
    setValue("courseRating", 0);
  },[])

  // what happens on Submit function 
  const onSubmit = async (data) =>{
    await createRating({
      courseId: courseEntireData._id,
      rating: data.courseRating,
      review: data.courseExprience
    }, token)

    setReviewModal(false);
  }
  // Rating change 
  const ratingChange = (newRating) =>{
    setValue("courseRating", newRating);
  }

  return (
    <div className='fixed inset-0 z-[1000] !mt-0 grid h-screen w-screen place-items-center overflow-auto bg-white bg-opacity-10 backdrop-blur-sm'>
      <div className='my-10 w-11/12 max-w-[700px] rounded-lg border border-richblack-400 bg-richblack-800'>
        {/* Modal header */}
        <div className='flex items-center justify-between rounded-t-lg bg-richblack-700 p-5'>
          <p className='text-2xl font-semibold text-richblack-5'>Add Review</p>
          <button onClick={() => setReviewModal(false)}>
            <RxCross2 className='text-2xl text-richblack-50'/>
          </button>
        </div>
        {/* MOdal Body */}
        <div className='p-6'>
          <div className='flex items-center justify-center my-1 gap-3'>
            <img src={user?.image} alt={user?.firstName} className='aspect-square w-[50px] rounded-full object-cover' />

            <div className=''>
              <p className='font-semibold text-richblack-5'>{user?.firstName} {user?.lastName}</p>
              <p className='font-sm text-richblack-5'>Posting Publicly</p>
            </div>
          </div>
          
          {/* form  */}
          <form
            onSubmit={handleSubmit(onSubmit)}
            className='mt-6 flex flex-col items-center'
          >
            <ReactStars 
              count={5}
              onChange={ratingChange}
              size={26}
              activeColor="#ffd700"
            />
            <div className='flex flex-col w-[95%] mx-auto my-4'>
              <label htmlFor="courseExperience" className='text-richblack-5'>
                Add Your Exprience
                <span className='text-pink-200'>*</span>
              </label>
              <textarea name="courseExprience" id="courseExprience" cols="20" rows="5" 
                className='bg-richblack-800 rounded-xl text-richblack-5 p-3 border-richblack-600 border-b-[2px] w-full min-h-[130px]'
                placeholder='Write Your Exprience About the course'
                {...register("courseExprience",{required: true})}
              />
              {
                errors.courseExprience && (
                  <span className='ml-2 text-xs tracking-wide text-pink-200'>
                    Please add your Exprience
                  </span>
                )
              }
            </div>
            <div className='mt-2 flex w-11/12 justify-end gap-x-2'>
              {/* cancel and save button */}
              <button onClick={() => setReviewModal(false)}
                className='flex cursor-pointer items-center gap-x-2 rounded-md bg-richblack-300 py-[8px] px-[20px] font-semibold text-richblack-900'
              >
                Cancel
              </button>
              <IconBtn 
                  text={"Save"}
                  type="submit"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}